export default "__VITE_ASSET__ByObpbib__"